<template>
  <section class="ppt-to-video">
    <SectionTemplate
      title="无需出镜与剪辑，AI数字人让PPT秒变专业视频"
      theme="light"
      desc="告别繁琐拍摄，上传PPT即可自动生成数字人讲解视频。独有的3D场景、电影运镜、多元形象与AI智能工具，让您的视频制作更简单、效果更出众。"
    >
      <div class="card-list">
        <FeatureCard
          v-for="(feature, index) in featureList"
          :key="index"
          v-bind="feature"
          btnText="免费试用"
        />
      </div>
    </SectionTemplate>
  </section>
</template>

<script setup lang="ts">
import FeatureCard from '@/design/components/feature-card/index.vue';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';

const handleTry = () => {
  window.open(`${location.origin}/editor/get-started?id=4`, '_blank');
};

const featureList = [
  {
    title: `无需真人出镜录制
AI自动生成讲解`,
    description:
      '无需真人出镜或复杂剪辑。您只需上传PPT，AI便能自动匹配语音、口型与动作，快速生成专业讲解视频，极大降低制作门槛与个人出镜压力。',
    image: transformImage(getFeUrl('/youyan-platform/ppt-or-pdf/type-1.jpg')),
    muted: false,
    action: handleTry,
  },
  {
    title: `影视级3D场景+AI运镜
让PPT讲解如临现场`,
    description:
      '超越普通的“人像+幻灯片”。您的PPT可置于3D虚拟场景中，数字人结合内容走动讲解，镜头随之动态切换，打造沉浸式观感，让视频质感脱颖而出。',
    image: transformImage(getFeUrl('/youyan-platform/ppt-or-pdf/type-2.jpg')),

    reverse: true,
    action: handleTry,
  },
  {
    title: `3000+人物形象、400+声音
精准匹配视频风格`,
    description:
      '提供从超写实真人到定制卡通的海量形象，并拥有超400种AI声音。您可自由搭配形象与音色，精准适配商务、教育、科普等不同视频的风格与情感需求。',
    image: transformImage(getFeUrl('/youyan-platform/ppt-or-pdf/type-3.jpg')),
    action: handleTry,
  },
  {
    title: `AI生成讲稿、AI翻译、AI生成PPT
解放创作生产力全面提效`,
    description:
      '提供全链路AI提效：一键生成或优化演讲稿；支持数十种语言的一键翻译与配音，轻松制作多语种视频；还能通过丰富模板AI生成PPT，彻底解放您的创作力。',
    image: transformImage(getFeUrl('/youyan-platform/ppt-or-pdf/type-4.jpg')),
    reverse: true,
    action: handleTry,
  },
];
</script>

<style lang="scss" scoped>
.ppt-to-video {
  background: var(--back-3);
}
.card-list {
  @apply flex-col items-center gap-[240px];
}
</style>
